module.exports = __webpack_public_path__ + "static/media/sombra-miolo-debru.1bc1f610.svg";